import { useState } from "react";
import { Monitor, Smartphone, Loader2 } from "lucide-react";

// Renders the exact HTML the recipient receives, sandboxed so nothing in it can run.
export const EmailPreviewFrame = ({ preview, loading }) => {
  const [device, setDevice] = useState("desktop");
  const width = device === "desktop" ? 620 : 375;
  return (
    <div className="flex h-full min-h-0 flex-col rounded-lg border border-border bg-slate-100" data-testid="email-preview">
      <div className="flex items-center justify-between gap-2 border-b border-border bg-white px-3 py-2">
        <div className="min-w-0 text-xs">
          <p className="truncate"><span className="text-muted-foreground">Subject: </span><strong data-testid="preview-subject">{preview?.subject || "—"}</strong></p>
          {preview?.sample && <p className="truncate text-[11px] text-muted-foreground" data-testid="preview-sample">Shown as {preview.sample.name} &lt;{preview.sample.email}&gt;</p>}
        </div>
        <div className="flex shrink-0 items-center gap-1">
          {loading && <Loader2 size={12} className="animate-spin text-slate-400" />}
          {[["desktop", Monitor], ["mobile", Smartphone]].map(([d, Icon]) => (
            <button key={d} type="button" onClick={() => setDevice(d)} title={d === "desktop" ? "Desktop" : "Mobile"}
              className={`rounded p-1.5 ${device === d ? "bg-green-100 text-green-800" : "text-slate-500 hover:bg-slate-100"}`} data-testid={`preview-${d}`}><Icon size={14} /></button>
          ))}
        </div>
      </div>
      <div className="flex min-h-0 flex-1 justify-center overflow-auto p-3">
        {preview?.html
          ? <iframe title="Email preview" sandbox="" srcDoc={preview.html} style={{ width, minWidth: width }} className="h-full min-h-[520px] rounded-md border border-border bg-white shadow-sm transition-[width] duration-300" data-testid="preview-iframe" />
          : <p className="self-center text-xs text-muted-foreground">Start writing to see the finished email here.</p>}
      </div>
    </div>
  );
};
